export function getInitialRoute(user = {}) {
  const permission = user.permissao || {};
  const route = permission.rota_inicial;

  if (!route) return "/dashboard";
  if (typeof route === "string") return route || "/dashboard";
  if (route.rota) return route.rota;
  if (route.path) return route.path;

  return "/dashboard";
}

export function goToInitialRoute(router, user = {}) {
  const route = getInitialRoute(user);
  return router.push(route).catch(() => {});
}
